const ONBOARDING_MAX_STEP = 4;

const AVATAR_SIZE = {
  BIG: 'BIG',
  SMALL: 'SMALL',
  PORTRAIT: 'PORTRAIT',
};

type UserSuggestFilter =
  | 'FILTER_UNSPECIFIED'
  | 'FILTER_ALL'
  | 'FILTER_STREAM'
  | 'FILTER_ONBOARDING';

// DISCOVER PEOPLE
const ONBOARDING_USER_SUGGEST_LIMIT = 30;
const ONBOARDING_USER_SUGGEST_PAGE = 1;
const ONBOARDING_USER_SUGGEST_FILTER: UserSuggestFilter = 'FILTER_ONBOARDING';

const ONBOARDING_REQUEST_FILTER = {
  limit: ONBOARDING_USER_SUGGEST_LIMIT,
  page: ONBOARDING_USER_SUGGEST_PAGE,
  filter: ONBOARDING_USER_SUGGEST_FILTER,
};

export { ONBOARDING_MAX_STEP, AVATAR_SIZE, ONBOARDING_REQUEST_FILTER };
